import { Component, OnInit, OnChanges, SimpleChanges, input, signal, WritableSignal } from "@angular/core";
import { ClozeTestService } from "../../../service/cloze-test.service";
import { AnswerDto } from "../../../dto/answer-dto";

@Component({
  selector: "onset-cloze-test-exercise-input-field",
  templateUrl: "./input-field.component.html",
  standalone: true,
  styleUrls: ["./input-field.component.scss"],
  imports: [],
})
export class InputFieldComponent implements OnInit, OnChanges {
  readonly inputText = input("");
  readonly inputNumber = input<number>(0);
  readonly answer = input<AnswerDto>({
    buchungId: 0,
    aufgabeId: 0,
    nr: 0,
    antwort: "",
  });
  readonly currentAnswer: WritableSignal<AnswerDto> = signal({} as AnswerDto);

  readonly MAX_ANSWER_CHAR_COUNT = 20;

  inputs: string[] = [];
  currentIndex = 0;

  constructor(private clozeTestService: ClozeTestService) {}

  ngOnInit() {
    this.currentAnswer.set(this.answer());
    this.inputs = this.inputText().split("");

    this.clozeTestService.insertSpecialCharacterToInput$$.subscribe((character: string) => {
      if (this.clozeTestService.inputNumber === this.inputNumber()) {
        this.addCharacterToInput(character);
      }
    });

    this.clozeTestService.removeLastCharacter$$.subscribe(() => {
      if (this.clozeTestService.inputNumber === this.inputNumber()) {
        this.removeCharacterFromInput();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (Object.hasOwn(changes, propName)) {
        switch (propName) {
          case "inputText": {
            this.inputs = this.inputText().split("");
          }
        }
      }
    }
  }

  public isActiveInput(): boolean {
    return this.clozeTestService.inputNumber === this.inputNumber();
  }

  public showIndicator(index: number): boolean {
    if (
      this.inputs.length > 0 &&
      this.currentIndex === this.inputs.length &&
      index === this.currentIndex - 1 &&
      this.isActiveInput()
    ) {
      return true;
    } else if (index === this.currentIndex && this.isActiveInput()) {
      return true;
    }
    return false;
  }

  // convert string array back to string and update the answer
  onInputChange(): void {
    this.currentAnswer.set({
      ...this.currentAnswer(),
      antwort: this.inputs.join(""),
    });
    console.log("answer: " + this.currentAnswer().antwort);
  }

  onCharClick(index: number) {
    this.currentIndex = index;
  }

  addCharacterToInput(character: string): void {
    if (this.currentIndex === 0 && this.inputs.length === 0) {
      this.inputs.splice(this.currentIndex, 0, character);
      this.onInputChange();
    } else if (this.currentIndex < this.MAX_ANSWER_CHAR_COUNT) {
      this.currentIndex++;
      this.inputs.splice(this.currentIndex, 0, character);
      this.onInputChange();
    }
  }

  removeCharacterFromInput(): void {
    if (this.currentIndex > 0) {
      this.inputs.splice(this.currentIndex, 1);
      this.currentIndex--;
      this.onInputChange();
    } else if (this.currentIndex === 0) {
      this.inputs.splice(this.currentIndex, 1);
      this.onInputChange();
    }
  }
}
